export default __webpack_public_path__ + "static/favicon-f8d0221c484ce86a11635bb7745abe3b.png";